import { AppRootState } from '../../../../../store/models/app-state.model';

export const getHasFormErrorSelector = (state: AppRootState): boolean =>
  state.campaignsFeature.basicInfo.hasFormError;
